export default "__VITE_ASSET__C6kVgO_$__"